import React, { useMemo } from "react";
import styled from "styled-components";
import TreeMap from "@charty/content-classification/tree-map-chart";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { DatavizTreeMap } from "@radarly/models/dataviz";
import { SearchFragmentClassification } from "@radarly/models/search";
import Empty from "../../empty";
import { computeSeriesToTree } from "../compute";

const Container = styled.div`
  height: 100%;
`;

export interface SharedWidgetsClassificationTreeMapInnerProps {
  loading: boolean;
  data: SearchFragmentClassification["data"];
  fragment: SearchFragmentClassification;
  dataviz: DatavizTreeMap;
  className?: string;
  onClickItem?: (uid: string | number) => void;
  disableAnimation?: boolean;
}

export default function SharedWidgetsClassificationsTreeMapInner({
  loading,
  data,
  fragment,
  dataviz,
  className,
  onClickItem,
  disableAnimation,
}: SharedWidgetsClassificationTreeMapInnerProps) {
  const locale = useCurrentUserLocale();
  const metric = fragment.request.aggs.contentClassification.metrics[0];
  const nodesLimitByChildren = dataviz.nodesLimitByChildren;
  const nodesLimitByDepth = dataviz.nodesLimitByDepth;
  const series = useMemo(() => {
    return computeSeriesToTree(
      data ? data.aggs.contentClassification.values : [],
      metric,
      locale,
      nodesLimitByChildren,
      nodesLimitByDepth
    );
  }, [data, locale, metric, nodesLimitByChildren, nodesLimitByDepth]);
  return (
    <Empty empty={!series.children.length}>
      <Container className={className}>
        <TreeMap
          series={series}
          metric={metric}
          locale={locale}
          onClickBranch={onClickItem}
          disableAnimation={disableAnimation}
        />
      </Container>
    </Empty>
  );
}
